export interface Token {
    token: string;
    token_type: string;
    user: any;
}

export interface ChatUser {
    dateTime: Date;
    userId: number;
    firstName: string;
    lastName: string;
    text: string;
    messageType: number;
    type: number;
    unreadCount: number;
}

export interface ChatMessage {
    uid: string;
    supportId: number;
    userId: number;
    text: string;
    image: string;
    fileName: string;
    dateTime: Date;
    type: number;
}

export interface ChatMessageBody {
    fileName: string;
    messageBody: string;
}

export interface TravelContract {
    id: number;
    status: number;
    policyId: number;
    policyNumber: string;
    policyPrintFileUrl: string;
    travelPurpose: number;
}

export class TravelCalculateForm {
    birthDates: Array<Date> = [];
    startDate: Date = new Date();
    endDate: Date | null = null;
    countryId: number | null = null;
    currencyId: number | null = null;
    periodId: number | null = null;
    amount: number | null = null;
    purpose: number | null = null;
    covidRiskAvailable: boolean = false;
    covidCoverage: number | null = null;
}

export interface TravelCalculateResult {
    startDate: Date;
    endDate: Date;
    country: string;
    currency: string;
    period: string;
    insuredPersons: Array<TravelInsuredPerson>;
}

export interface TravelInsuredPerson {
    isCalculated: boolean;
    premium: number
    currency: string;
    birthDate: Date
}

export class TravelIssueForm {
    startDate: Date = new Date();
    endDate: Date | null = null;
    countryId: number | null = null;
    currencyId: number | null = null;
    periodId: number | null = null;
    amount: number | null = null;
    purpose: number | null = null;
    phoneNumber: number | null = null;
    covidRiskAvailable: boolean = false;
    covidCoverage: number | null = null;
    insuredPersons: Array<TravelIssuePerson> = [];
}

export class TravelIssuePerson {
    firstName: string = "";
    lastName: string = "";
    passportNumber: string = "";
    identitySerial: string = "";
    identityNumber: string = "";
    pinCode: string = "";
    birthDate: Date = new Date();
    gender: number = 1;
}

export class TravelIssueResult {
    policyNumber: string = "";
    insuredPerson: string = "";
    premium: number = 0;
    currency: string = "";
}

export interface UserForm {
    email: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    password: string;
}